import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { colors, inr } from "@/theme";
import { SectionTitle, Spinner } from "@/components/common";
import { useIsMobile } from "@/hooks/useMediaQuery";
import { Sparkles } from "lucide-react";

export default function Points() {
  const [data, setData] = useState(null);
  const isMobile = useIsMobile();
  useEffect(() => { api("/points").then(setData).catch(() => setData({ balance: 0, transactions: [] })); }, []);

  if (!data) return <Spinner full />;

  return (
    <div className="container-max fade-up" style={{ padding: isMobile ? "24px 16px 40px" : "40px 24px 56px", maxWidth: 760 }}>
      <SectionTitle eyebrow="Loyalty" title="Nest Rewards" />
      <div style={{ background: colors.brand, borderRadius: 14, padding: isMobile ? 28 : 40, color: colors.onBrandPrimary, position: "relative", overflow: "hidden" }}>
        <Sparkles size={120} style={{ position: "absolute", right: -20, top: -20, opacity: 0.12 }} />
        <div className="eyebrow" style={{ color: "rgba(252,251,248,0.8)" }}>Your Balance</div>
        <div className="font-display" style={{ fontSize: 56, fontWeight: 700, lineHeight: 1, marginTop: 8 }} data-testid="points-balance">{data.balance}</div>
        <div className="font-body" style={{ marginTop: 8, opacity: 0.9 }}>Worth {inr(data.value_rupees)} · Earn {Math.round((data.rate_per_rupee || 0.1) * 100)} pts per ₹100 spent</div>
      </div>

      <h3 className="font-display" style={{ fontSize: 22, fontWeight: 700, marginTop: 36, marginBottom: 12 }}>Activity</h3>
      {data.transactions.length === 0 ? (
        <p className="font-body" style={{ color: colors.mutedText }}>No activity yet. Start shopping to earn points!</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {data.transactions.map((t) => (
            <div key={t.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 0", borderBottom: `1px solid ${colors.border}` }}>
              <div>
                <div className="font-body" style={{ fontWeight: 600, textTransform: "capitalize" }}>{(t.reason || "").replace(/_/g, " ")}</div>
                <div className="font-body" style={{ fontSize: 12, color: colors.mutedText }}>{new Date(t.created_at).toLocaleDateString()}</div>
              </div>
              <div className="font-body" style={{ fontWeight: 700, color: t.type === "earn" ? colors.brand : colors.accentDark }}>
                {t.type === "earn" ? "+" : "−"}{t.amount}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
